module.exports = __webpack_public_path__ + "static/Snap-Photo-8d2c37d1f90ad51e43641cacd1824655.svg";